var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createTRPCClient, httpLink } from "@trpc/client";
import API_service from "@iscr/xAppLib/providers/API_service";
//	The app's single tRPC client, shared by the React bindings (see QueryProvider) and by imperative callers outside
//	the component tree - class components, module-level helpers and event handlers, none of which can use the
//	`useTRPC` hook.
//
//	Built on first use rather than at module load, because API_BASE_URL is only resolved once ws_conf has loaded at
//	boot. The auth token is read per request inside `fetch`, so a client built before sign-in still works afterwards.
let client;
export function getTRPCClient() {
    client !== null && client !== void 0 ? client : (client = createTRPCClient({
        links: [
            httpLink({
                url: `${API_service.API_BASE_URL}rpc`,
                fetch: (input, init) => __awaiter(this, void 0, void 0, function* () {
                    const token = yield app.user.idtoken();
                    return yield fetch(input, Object.assign(Object.assign({}, init), { headers: Object.assign(Object.assign(Object.assign({}, init === null || init === void 0 ? void 0 : init.headers), API_service.getCommonRequestHeaders()), (token && {
                            Authorization: `Bearer ${token}`,
                        })) }));
                }),
            }),
        ],
    }));
    return client;
}
